/** Synthesised Snake sound effects for the hidden arcade (C). */
const SILENT = 0.0001;

function defaultAudioContextFactory() {
    if (typeof window === 'undefined') {
        return null;
    }
    const Ctor = window.AudioContext || window.webkitAudioContext;
    return Ctor ? new Ctor() : null;
}

export function createSnakeSound({ audioContextFactory = defaultAudioContextFactory, muted = false } = {}) {
    let ctx = null;
    let triedFactory = false;
    let isMuted = !!muted;
    let disposed = false;

    function tone(freq, duration = 0.08, at = 0, type = 'square', gainValue = 0.1) {
        const start = (ctx.currentTime || 0) + at;
        const gain = ctx.createGain();
        gain.gain.setValueAtTime(gainValue, start);
        gain.gain.exponentialRampToValueAtTime(SILENT, start + duration);
        gain.connect(ctx.destination);
        const osc = ctx.createOscillator();
        osc.type = type;
        osc.frequency.setValueAtTime(freq, start);
        osc.connect(gain);
        osc.start(start);
        osc.stop(start + duration + 0.02);
    }

    const effects = {
        start: () => [440, 660].forEach((freq, i) => tone(freq, 0.1, i * 0.09)),
        eat: () => tone(880, 0.06),
        levelUp: () => [660, 880, 1100].forEach((freq, i) => tone(freq, 0.09, i * 0.07, 'triangle')),
        gameOver: () => [330, 220, 110].forEach((freq, i) => tone(freq, 0.2, i * 0.16, 'sawtooth', 0.15)),
    };

    return {
        unlock() {
            if (disposed) {
                return;
            }
            if (!ctx && !triedFactory) {
                triedFactory = true;
                ctx = audioContextFactory() || null;
            }
            if (ctx && ctx.state !== 'running' && typeof ctx.resume === 'function') {
                const resumed = ctx.resume();
                if (resumed && typeof resumed.catch === 'function') {
                    resumed.catch(() => {});
                }
            }
        },
        play(event) {
            if (!ctx || disposed || isMuted || !event || !effects[event.type]) {
                return;
            }
            effects[event.type](event);
        },
        setMuted(value) {
            isMuted = !!value;
        },
        isMuted() {
            return isMuted;
        },
        dispose() {
            if (ctx && typeof ctx.close === 'function') {
                const closed = ctx.close();
                if (closed && typeof closed.catch === 'function') {
                    closed.catch(() => {});
                }
            }
            disposed = true;
        },
    };
}
